
import { request,pretty } from '@/utils/request' 
export const addAIModelConfig = (item)=>{
  return pretty(request.post("/api/AIModelConfig/Add",{...item}));
}
export const deleteAIModelConfig = (item)=>{
  return pretty(request.post(`/api/AIModelConfig/Delete?ids=${item}`));
}
export const detailAIModelConfig = (item)=>{
  return pretty(request.get(`/api/AIModelConfig/Detail?id=${item}`));
}
export const editAIModelConfig = (item)=>{
  return pretty(request.post("/api/AIModelConfig/Edit",{...item}));
}
export const listAIModelConfig = (item)=>{
  return pretty(request.get(`/api/AIModelConfig/List?pageSize=${item?.pageSize?(item?.pageSize):10}&pageIndex=${item?.pageIndex?(item?.pageIndex):1}`));
}
export const companyTypeAIModelConfig = (item)=>{
  return pretty(request.post('/api/AIModelConfig/CompanyType'));
}